(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-latest-youtube"] && !Shopify.designMode) return;
  try {
    
(() => {
  const endpoint = 'https://coralprime-youtube-latest.spring-cake-3ff7.workers.dev/latest.json';
  const channel = 'UCapdo1JhmqH8f5m6_dcmJSg';
  let latest;
  function init(scope) {
    scope.querySelectorAll('[data-cp-youtube]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      let playing = false;
      const frame = section.querySelector('[data-video-frame]');
      section.querySelectorAll('[data-video-play]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        const id = section.dataset.videoId;
        if (!/^[\w-]{11}$/.test(id)) return;
        event.preventDefault();
        if (playing) { frame.querySelector('iframe')?.focus(); return; }
        playing = true;
        const player = document.createElement('iframe');
        const language = section.dataset.language.startsWith('en') ? 'en' : 'de';
        player.src = 'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0&hl='+language+'&cc_lang_pref='+language;
        player.title = section.dataset.playerLabel;
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.replaceChildren(player);
        player.focus();
        frame.scrollIntoView({block:'nearest',behavior:'auto'});
      }));
      latest ||= fetch(endpoint,{credentials:'omit',signal:AbortSignal.timeout(6000)}).then(response => {if(!response.ok) throw Error('video feed'); return response.json();}).catch(()=>null);
      latest.then(video => {
        if (!video || playing || video.channelId !== channel || !/^[\w-]{11}$/.test(video.id) || typeof video.title !== 'string' || video.title.length > 300) return;
        section.dataset.videoId = video.id;
        const url = 'https://www.youtube.com/watch?v='+video.id;
        section.querySelectorAll('[data-video-play],[data-video-title]').forEach(link => link.href = url);
        const title = section.querySelector('[data-video-title]');
        if (!section.dataset.language.startsWith('en') || video.id !== 'QzMt3f9p_y4') { title.textContent = video.title; title.lang = 'de'; }
        const image = section.querySelector('[data-video-image]');
        const next = new Image();
        next.onload = () => {if(!playing) image.src = next.src;};
        next.src = endpoint.replace('/latest.json','/thumbnail/'+video.id+'.jpg');
        section.dataset.checkedAt = video.checkedAt;
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function setupArticleSharing(root=document){
    root.querySelectorAll('[data-article-share]').forEach(box=>{
      if(box.dataset.ready)return;
      box.dataset.ready='true';
      const status=box.querySelector('[data-share-status]');
      const fallback=box.querySelector('[data-share-fallback]');
      const copy=async()=>{
        try{
          await navigator.clipboard.writeText(box.dataset.url);
          fallback.hidden=true;
          status.textContent=box.dataset.copied;
        }catch(error){
          fallback.hidden=false;
          fallback.focus();
          fallback.select();
          status.textContent=box.dataset.fallback;
        }
      };
      box.querySelector('[data-copy-link]').addEventListener('click',copy);
      const native=box.querySelector('[data-native-share]');
      if(typeof navigator.share==='function'){
        native.hidden=false;
        native.addEventListener('click',async()=>{
          try{await navigator.share({title:box.dataset.title,url:box.dataset.url});}
          catch(error){if(error.name!=='AbortError')await copy();}
        });
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setupArticleSharing(),{once:true});
  else setupArticleSharing();
  document.addEventListener('shopify:section:load',event=>setupArticleSharing(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-recommendations][aria-busy="true"]');

    sections.forEach((recommendationSection) => {
      const loadRecommendations = () => {
        fetch(recommendationSection.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const refreshed = parsed.querySelector('[data-product-recommendations]');

            if (refreshed && refreshed.innerHTML.trim()) {
              recommendationSection.innerHTML = refreshed.innerHTML;
              recommendationSection.setAttribute('aria-busy', 'false');
            } else {
              recommendationSection.remove();
            }
          })
          .catch(() => recommendationSection.remove());
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, { rootMargin: '0px 0px 320px 0px' });
        observer.observe(recommendationSection);
      } else {
        loadRecommendations();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
